import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { format } from "date-fns";
import { fr } from "date-fns/locale";

const DetailsSection = ({ student }) => {
    if (!student) {
        return <div>Chargement...</div>; // Loader simple
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : format(date, "dd/MM/yyyy", { locale: fr });
    }

    return (
        <React.Fragment>
            <Col xl={9}>
                <Card>
                    <CardBody className="border-bottom">
                        <div className="d-flex">
                            <div className="flex-grow-1 ms-3">
                                <h5 className="fw-semibold">{student.first_name || "-"} {student.last_name || "-"}</h5>
                                <ul className="list-unstyled hstack gap-2 mb-0">
                                    <li>
                                        <i className="bx bx-phone-call"></i> <span className="text-muted">{student.phone || "-"}</span>
                                    </li>
                                    <li>
                                        <i className="bx bx-envelope"></i> <span className="text-muted">{student.email || "-"}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </CardBody>
                    <CardBody>
                        <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th>Sexe</th>
                                        <td>{student.sex || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Date de naissance</th>
                                        <td>{formatDate(student.birth_date)}</td>
                                    </tr>
                                    <tr>
                                        <th>Lieu de naissance</th>
                                        <td>{student.birth_place || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Nationalité</th>
                                        <td><span className="badge badge-soft-success">{student.nationality || "-"}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Année du BAC</th>
                                        <td>{student.baccalaureate_year || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Série du BAC</th>
                                        <td>{student.baccalaureate_series || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Mention</th>
                                        <td>{student.baccalaureate_mention || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Matricule CNOU</th>
                                        <td>{student.cnou_registration_number || "-"}</td>
                                    </tr>
                                    {/*
                                    <tr>
                                        <th>Faculté</th>
                                        <td>{student.faculty_name || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Filière</th>
                                        <td>{student.branch_name || "-"}</td>
                                    </tr>
                                    */}
                                    
                                    <tr>
                                        <th>Nom du père</th>
                                        <td>{student.father_firstname || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Prénom mère</th>
                                        <td>{student.mother_firstname || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Nom mère</th>
                                        <td>{student.mother_lastname || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Nom tuteur</th>
                                        <td>{student.tutor_name || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Téléphone tuteur</th>
                                        <td>{student.tutor_phone || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Situation familiale</th>
                                        <td>{student.family_situation || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Lieu de résidence</th>
                                        <td>{student.residence_place || "-"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default DetailsSection;
